import EditIcon from '@mui/icons-material/Edit'
import { Box, Button, Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import DropDownOA from '../../../common/dropDownOA'
import { isEmpty, navigation3 } from '../../../common/helper'
import LineInputV3 from '../../../common/lineInputV3'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { cargoServiceTypes, serviceTypeHead } from './rateMatrixConstants'
import { GetServiceTypeListAllTableData, serviceTypeInsertUpdate } from '../../../../store/generalSetting/GSAction'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { updateAlertError } from '../../../../store/common/common_action'

const DefineCargoServiceType = (props) => {
  const { data, GetServiceTypeListAllTableData, serviceTypeInsertUpdate, updateAlertError } = props
  const theme = useTheme()
  const { common, generalSettingReducer } = data
  const { loginData } = common
  // const { common, generalSettingReducer } = data
  // const { cityList, loginData, cityBranchMatrix: cityBranchMatrixList } = { ...common }
  const { serviceTypeListAllTableData, serviceTypeListAll2 } = generalSettingReducer
  const [serviceTypeList, setServiceTypeList] = useState([])
  const [selectedServiceType, setSelectedServiceType] = useState('')
  const [newServiceTypeInput, setNewServiceTypeInput] = useState('')
  const [disableAdd, setDisableAdd] = useState(true)
  const [showTable, setShowTable] = useState(true)

  useEffect(() => {
    if (!isEmpty(loginData)) {
      if (Number(serviceTypeListAll2?.[0]?.CargoServiceTypeID) === 1) {
        setSelectedServiceType(cargoServiceTypes[1])
        setDisableAdd(false)
        const obj = {
          CargoServiceType: cargoServiceTypes[1]?.id,
          CompanyID: loginData?.intCompanyID,
          IsActive: -1
        }
        GetServiceTypeListAllTableData(obj)
      } else {
        setSelectedServiceType(cargoServiceTypes[0])
        setDisableAdd(true)
        const obj = {
          CargoServiceType: cargoServiceTypes[0]?.id,
          CompanyID: loginData?.intCompanyID,
          IsActive: -1
        }
        GetServiceTypeListAllTableData(obj)
      }
    }
  }, [serviceTypeListAll2, loginData])
  const loadServiceType = () => {
    const obj = {
      CargoServiceType: selectedServiceType?.id,
      CompanyID: loginData?.intCompanyID,
      IsActive: -1
    }
    GetServiceTypeListAllTableData(obj)
    setServiceTypeList([data])
    if (selectedServiceType?.id === 1) {
      setDisableAdd(false)
    }
    setShowTable(true)

    let obj1 = {
      CompanyID: loginData.intCompanyID,
      CargoServiceType: selectedServiceType?.id,
      ServiceTypeId: 0,
      ServiceType: '',
      IsActive: 0,
      UserID: loginData.intUserID,
      TypeID: 0,
      Mode: 0,
    }
    serviceTypeInsertUpdate(obj1)
    // if (selectedServiceType?.id === 1) {
    //   setServiceTypeList([])
    //   setDisableAdd(false)
    // } else {
    //   const data = {
    //     serviceTypeId: 1243,
    //     serviceType: 'Default',
    //     status: 'active',
    //     action: 'edit_disabled',
    //     modifiedBy: 'NA',
    //     modifiedTime: 'NA',
    //   }
    //   setServiceTypeList([data])
    // }
  }
  useEffect(() => {
    if (serviceTypeListAllTableData?.length > 0) {
      const updatedData = serviceTypeListAllTableData?.map((val) => ({ ...val, editBtn: true, serviceTypeId: val.ServiceTypeID, serviceType: val.ServiceType, status: val.IsActive, action: val.TypeID, modifiedBy: val.ModifiedBy, modifiedTime: moment(val.ModifiedDateTime).format('HH:mm DD MMM-YY') }))
      setServiceTypeList(updatedData)
    }

  }, [serviceTypeListAllTableData])

  const getTableData = () => {
    if (!isEmpty(loginData)) {
      const obj = {
        CargoServiceType: selectedServiceType?.id,
        CompanyID: loginData?.intCompanyID,
        IsActive: -1
      }
      GetServiceTypeListAllTableData(obj)
    }
  }
  const singleDefaltServiceInsertAPi = () => {
    let obj = {
      CompanyID: loginData.intCompanyID,
      CargoServiceType: 0,
      ServiceTypeId: 2,
      ServiceType: 'By Cargo',
      IsActive: 1,
      UserID: loginData.intUserID,
      TypeID: 0
    }
    serviceTypeInsertUpdate(obj)?.then((res) => {
      if (res?.status == 'Success') {
        updateAlertError({ show: true, msg: 'Updated', success: true, close: getTableData(), nextId: 'mpkngMop' })
        // if (index >= 0 && index <= newVal?.length) {
        //   newVal[index].editBtn = !newVal[index].editBtn
        //   setServiceTypeList(newVal)
        // }
      } else {
        updateAlertError({ show: true, msg: res.Message, success: false, nextId: '' })
      }
    }).catch((err) => {
      console.log("Error:", err)
    })
  }
  const addServiceType = () => {
    const serviceType = newServiceTypeInput
    if (!serviceType) return
    setNewServiceTypeInput('')
    let obj = {
      CompanyID: loginData.intCompanyID,
      CargoServiceType: selectedServiceType?.id === 1 ? 1 : 0,
      ServiceTypeId: 0,
      ServiceType: serviceType,
      IsActive: 1,
      UserID: loginData.intUserID,
      TypeID: 0,
      Mode: 1,
    }
    serviceTypeInsertUpdate(obj)?.then((res) => {
      if (res?.status == 'Success') {
        updateAlertError({ show: true, msg: 'Updated', success: true, close: getTableData(), nextId: 'mpkngMop' })
        // if (index >= 0 && index <= newVal?.length) {
        //   newVal[index].editBtn = !newVal[index].editBtn
        //   setServiceTypeList(newVal)
        // }
      } else {
        updateAlertError({ show: true, msg: res.Message, success: false, nextId: '' })
      }
    }).catch((err) => {
      console.log("Error:", err)
    })
    // const data = {
    //   serviceTypeId: Math.floor(Math.random() * 1000),
    //   serviceType: serviceType,
    //   status: 'active',
    //   action: 'edit',
    //   modifiedBy: loginData.strUserName,
    //   modifiedTime: moment().format('HH:mm DD MMM-YY'),
    //   apiTime: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    // }
    // setServiceTypeList([...serviceTypeList, data])
  }
  const handleCheckBox = (e, index) => {
    let newVal = [...serviceTypeList]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].status = e.target.checked ? 1 : 0
      setServiceTypeList(newVal)
    }
  }

  const handleEditData = (index) => {
    let newVal = [...serviceTypeList]
    if (index >= 0 && index <= newVal?.length) {
      for (let i = 0; i < newVal?.length; i++) {
        if (i === index) {
          newVal[i].editBtn = !newVal[i].editBtn
        } else {
          newVal[i].editBtn = true
        }
      }
      setServiceTypeList(newVal)
      // focusElemnt(`editBtn-${index + 1}`)
      // newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
    }
  }
  const handleRightBtn = (row, index) => {
    let newVal = [...serviceTypeList]
    let obj = {
      CompanyID: loginData.intCompanyID,
      CargoServiceType: selectedServiceType?.id === 1 ? 0 : 1,
      ServiceTypeId: 0,
      ServiceType: row.ServiceType,
      IsActive: row.status,
      UserID: loginData.intUserID,
      TypeID: row.TypeID,
      Mode: 1,
    }
    serviceTypeInsertUpdate(obj)?.then((res) => {
      if (res?.status == 'Success') {
        updateAlertError({ show: true, msg: 'Updated', success: true, close: getTableData(), nextId: 'mpkngMop' })
        if (index >= 0 && index <= newVal?.length) {
          newVal[index].editBtn = !newVal[index].editBtn
          setServiceTypeList(newVal)
        }
      } else {
        updateAlertError({ show: true, msg: res.Message, success: false, nextId: `editBtn-${index}` })
      }
    }).catch((err) => {
      console.log("Error:", err)
    })
  }

  const handleCrossBtn = (index) => {
    let newVal = [...serviceTypeList]
    if (index >= 0 && index <= newVal?.length) {
      // newVal[index].packingName = serviceTypeList[index].MOPName
      newVal[index].status = serviceTypeList[index].IsActive
      newVal[index].editBtn = !newVal[index].editBtn
      setServiceTypeList(newVal)
      // setTimeout(() => {
      //     focusElemnt(`editBtn-${index + 1}`)
      // }, 0)
    }
  }
  // useEffect(()=>{
  //   // selectedServiceType?.id === 1 ? 1 : 0
  //   if (selectedServiceType?.id ===0) {
  //     if (serviceTypeList?.length===0) {
  //       singleDefaltServiceInsertAPi()
  //     }
  //   }
  // },[])
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 0' }}>
        <Box sx={{ display: 'flex', gap: '16px' }} className="reportButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Cargo_Service_Type'}
              label={'Cargo Service Type'}
              data={cargoServiceTypes}
              defaultvalue={selectedServiceType?.name || ''}
              value={selectedServiceType?.name || ''}
              onSelect={(seviceType) => {
                setSelectedServiceType(seviceType)
                setDisableAdd(true)
                setShowTable(false)
              }}
              idKey={`id`}
              dataKey={`name`}
              minWidth="230px"
              nextId={``}
              prevId={``}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => { })}
              id={'search_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={() => loadServiceType()}
            >
              save
            </Button>
          </Item>
          <Item className="input--wrapper" sx={sx.itemsx}>
            <LineInputV3
              id={'Cargo_Service_Type'}
              label={'Service Type'}
              disabled={disableAdd}
              onBlur={(e) => setNewServiceTypeInput(e.target.value)}
              minWidth="200px"
              nextId={``}
              prevId={``}
              value={newServiceTypeInput}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => { })}
              id={'search_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={() => addServiceType()}
              disabled={disableAdd}
            >
              add
            </Button>
          </Item>
        </Box>
      </Box>
      {
        showTable &&
        <TableContainer component={Paper} style={{ marginBottom: '5px', width: 'fit-content' }}>
          {serviceTypeList.length > 0 && (
            <Table
              stickyHeader
              size="small"
              aria-label="a dense table"
              sx={{
                '&.MuiTableCell-root': {
                  padding: '6px 8px!important',
                },
                width: 'unset',
              }}
            >
              <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                <TableRow>
                  {serviceTypeHead.map((col, index) => (
                    <TableCell
                      key={`TH-${index}`}
                      sx={{
                        ...col.headerSx,
                        backgroundColor: '#DAEDFE',
                        minHeight: '40px',
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#444',
                      }}
                    >
                      {col.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {serviceTypeList.length > 0 && (
                <TableBody>
                  {serviceTypeList.map((item, index) => (
                    <TableRow key={index}>
                      {/* {serviceTypeHead.map((col, index) => (
                      <TableCell key={`TC-${index}`} sx={{...col.headerSx,fontSize:'12px'}}>
                        {col.field === 'action' && <StyledEdit disabled={item[col.field] === 'edit_disabled'} />}
                        {col.field === 'status' && <StyledCheckbox checked={item[col.field]}/>}
                        {!['action', 'status'].includes(col.field) && item[col.field]}
                      </TableCell>
                    ))} */}
                      <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                        {item.serviceTypeId}
                      </TableCell>
                      <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                        {item.serviceType}
                      </TableCell>
                      <TableCell style={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox checked={item.status === 1} sx={{ padding: 0 }}
                          onChange={(e) => item.editBtn ? "" : handleCheckBox(e, index)}
                        // onChange={(e) => handleCheckBox(e, index)} 
                        />
                        {/* "IsActive" */}
                      </TableCell>
                      <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '12%', padding: '0px 16px 0px 16px' }}>
                        {item.editBtn ? (
                          <span
                            id={`editBtn-${index}`}
                            tabIndex={0}
                            style={{
                              display: 'flex',
                              color: selectedServiceType?.id === 0 ? '#888888' : '#007bfd',
                              fontSize: '13px',
                              fontWeight: 'bold',
                              width: '52px',
                              padding: '2px 4px',
                              marginLeft: '-6px',
                              cursor: selectedServiceType?.id === 0 ? 'not-allowed' : 'pointer',
                              pointerEvents: selectedServiceType?.id === 0 ? 'none' : 'auto', // Disable click
                              opacity: selectedServiceType?.id === 0 ? 0.5 : 1, // Visually indicate disabled state
                            }}
                            onClick={() => { if (selectedServiceType?.id !== 0) handleEditData(index); }}
                          >
                            <EditIcon sx={{ marginRight: '3px' }} />
                            Edit
                          </span>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                            <span
                              tabIndex={0}
                              key={`checkMark-${index}`}
                              id={`checkMark-${index}`}
                              onClick={() => handleRightBtn(item, index)}
                              style={{ cursor: 'pointer', marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                            >
                              <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize="large" />
                            </span>
                            <span
                              key={`xMark-${index}`}
                              tabIndex={0}
                              id={`xMark-${index}`}
                              onClick={() => handleCrossBtn(index)}
                              style={{ cursor: 'pointer', marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                            >
                              <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
                            </span>
                          </div>
                        )}
                      </TableCell>

                      <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                        {selectedServiceType?.id === 0 ? 'N/A' : item.modifiedBy}
                      </TableCell>
                      <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                        {selectedServiceType?.id === 0 ? 'N/A' : item.modifiedTime}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          )}
        </TableContainer>
      }
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { GetServiceTypeListAllTableData, serviceTypeInsertUpdate, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(DefineCargoServiceType)
